import { extractSize } from "../../../helpers/extractSize";
import { setActiveCalcValue, updateCalcForPlacement } from "../../calculator";
import { getTableSize, hideAndRemove } from "../helpers";
import { changePolkaStellazhi } from "./stellazhi/changePolkaStellazhi";
import { MIN_MAX_STELLAZHI } from "./stellazhi/pos_map";
import { changeElektropanelSP } from "./stoli_podkatnie/changeElektropanelSP";
import { changePokritiePolokSP } from "./stoli_podkatnie/changePokritiePolok";
import { changeRuchkaSyomnaya } from "./stoli_podkatnie/changeRuchkaSyomnaya";
import { changeTableTumbaSP } from "./stoli_podkatnie/changeTableTumbaSP";
import { changeStoykiDerzhatelRulona } from "./stoyki/changeStoykiDerzhatelRulona";
import {
    changeCornerTableSide,
    changeDerzhatelRulonaNizhnii,
    changeKontainerDlyaRabochikhOtkhodov,
    changeLotokDlyaProvodov,
    changePodstavkaPodSistemniiBlok,
    changePolkaDlyaKlaviatury,
    changePolkaKantsPrinadlezhnostei,
    changeShelfDown,
    changeShelfEquipment,
    changeTableAnnex,
    changeTableCover,
    changeTableStops,
    changeTableTumba,
    changeVerstakNozhki,
    changeVarstakStoleshnitsa,
    changeVarstakTumba,
    changeYashchikMKMetall,
    changeYashchikMKPlastik,
    changeRazdeliteliDownRaskroinii,
    changeVerstakPerekladini,
} from "./tables/down/down";
import {
    changeBokovieFiksatoriUp,
    changeDerzhatelMonitora,
    changeDerzhatelRuchnogoInstrumenta,
    changeDerzhatelRulonaBokovoi,
    changeDerzhatelRulonaUp,
    changeFiksatorRulonnikhMaterialov,
    changeInstrumentalnayaPlanka,
    changeKronshteinDlyaPrintera,
    changeLotokMetallicheskii,
    changeOsveshchenieBokovoe,
    changeOsveshchenieVerkhnee,
    changePanelElektromontazhnaya,
    changePerfopanel,
    changePerfopanelKSM,
    changePlankaDlyaLotkov,
    changePodstavkaDlyaChertezhei,
    changePolkaDlyaKlaviaturiIMishi,
    changePolkaKorotkaya,
    changePolkaNaklonnaya,
    changePolkaPribornaya,
    changePolkaPribornayaKSM,
    changePolkaPribornayaSMK,
} from "./tables/up/up";
import { changePerfopanelVerstak } from "./verstaki";
import { changeVerstakOpora } from "./verstaki/changeVerstakOpora";
import { changeVerstakPolka } from "./verstaki/changeVerstakPolka";
import { changeDoors } from "./wardrobes/changeDoors";
import { changePolkaWardrobes } from "./wardrobes/changePolkaWardrobes";
import { MIN_MAX_SHKAFY } from "./wardrobes/pos_map";

function restoreActiveElements(array, changeFn, getArgs) {
    const copy = [...array]; // Копия массива
    copy.forEach((el) => {
        const args = getArgs(el);
        changeFn(...args);
    });
}

export function updateTableDependencies(tableSizeType, tableSizeValue, visibleChildren = null) {
    const tableSize = getTableSize();
    const object = servObj.redactorModeObject;
    const isOstrov = object.name.includes("ostrov");
    const isSMK = object.name.includes("smk");
    const isVerstakCategory = object.userData.loadData.folderName === "verstaki";
    const tempName = servObj.tempName;
    const tableWidth = servObj.tableSize.tableWidth.current;
    const tableDepth = servObj.tableSize.tableDepth.current;
    // const is_checkbox_checked = event.target.checked;
    if (servObj.activeTableCover.length) {
        servObj.activeTableCover.forEach((cover) => {
            const name = cover.name;
            const tableCoverSize = extractSize(name);
            const mapTypes = {
                polikarbon: "polikarb",
                otsinkovka: "zink",
                metall_2: "metall2mm",
                metall_6: "metall6mm",
            };

            const type = Object.entries(mapTypes).find(([key]) => name.includes(key))?.[1] || null;

            if (tableCoverSize !== tableSize) {
                changeTableCover(type, true);

                const calc_name = (() => {
                    if (isOstrov) {
                        return `${type}__ostrov__${tableSize}`;
                    }

                    if (isVerstakCategory) {
                        const { tableWidth, tableDepth } = servObj.tableSize;
                        return `${type}__verstak__${tableWidth.current}x${tableDepth.current}`;
                    }

                    return `${type}__${tableSize}`;
                })();

                setActiveCalcValue(calc_name, true, 1, null, 1);
            }
        });
    }
    if (servObj.activeTableStops.length) {
        const toUpdate = [];
        servObj.activeTableStops.forEach((el) => {
            const name = el.name;
            const tableStopsSize = extractSize(name);
            const type = name.includes("zadnii") ? "zadnii" : name.includes("bokovoi") ? "bokovoi" : null;
            const currentTableSize = type === "zadnii" ? tableWidth : tableSize;
            if (currentTableSize !== tableStopsSize && type) {
                toUpdate.push(type);
            }
        });
        toUpdate.forEach((type) => {
            changeTableStops(type, true);

            let calc_stops_name = null;
            if (type === "zadnii") {
                calc_stops_name = isOstrov ? `zadnii__ostrov__${tableWidth}` : `zadnii__${tableWidth}`;
            }
            if (type === "bokovoi") {
                calc_stops_name = isOstrov ? `bokovoi__ostrov__${tableDepth}` : `bokovoi__${tableDepth}`;
            }
            setActiveCalcValue(calc_stops_name, true);
        });
    }
    if (servObj.activeCornerTable.length) {
        restoreActiveElements(servObj.activeCornerTable, changeCornerTableSide, (el) => [el.userData.placement]);
    }
    if (servObj.activeShelfDownSide.length) {
        const { type, size } = servObj.activeShelfDownSide[0].userData;

        if (isOstrov) {
            restoreActiveElements(servObj.activeShelfDownSide, changeShelfDown, (el) => [
                `${el.userData.type}_${el.userData.size}`,
                true,
                el.userData.placement,
            ]);
        } else {
            const { type, size } = servObj.activeShelfDownSide[0].userData;
            changeShelfDown(`${type}_${size}`, true);
        }

        const calc_name =
            isOstrov && type === "dsp"
                ? `polka_nizhnyaya__ostrov__${tableWidth}x${size}`
                : `polka_nizhnyaya__${type}__${tableWidth}x${size}`;

        if (isOstrov && type === "metall") {
            servObj.activeShelfDownSide.forEach((el) => {
                updateCalcForPlacement(calc_name, true, el.userData.placement);
            });
        } else {
            setActiveCalcValue(calc_name, true);
        }
    }
    if (servObj.activeTableAnnex.length) {
        servObj.activeTableAnnex.forEach((el) => {
            const name = el.name;

            const toDelete = servObj.activeTableAnnex.filter((obj) => obj.name.includes(name));
            // Удаляем из activeTableAnnex
            servObj.activeTableAnnex = servObj.activeTableAnnex.filter((el) => !el.name.includes(name));
            // Удаляем из сцены
            toDelete.forEach((obj) => hideAndRemove(obj));

            const type = name.includes("nizhnyaya") ? "nizhnyaya" : "verkhnyaya";
            const typee = name.includes("nizhnyaya") ? "down" : "up";
            const value = name.includes("left") ? "left" : "right";

            changeTableAnnex(type, value, true);
            const calc_name = `bokovaya_pristavka__${tableDepth}__${typee}__${value}`;
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePodstavkaPodSistemniiBlok.length) {
        restoreActiveElements(servObj.activePodstavkaPodSistemniiBlok, changePodstavkaPodSistemniiBlok, (el) => {
            const name = el.name;
            const type = name.includes("podkatnaya") ? "podkatnaya" : "podvesnaya";
            const side = name.includes("left") ? "left" : "right";
            return [type, true, side, el.userData.placement];
        });
    }
    if (servObj.activeLotokDlyaProvodov.length) {
        changeLotokDlyaProvodov(true);
        const calc_name = `lotok_dlya_provodov__${tableWidth}`;
        setActiveCalcValue(calc_name, true);
    }
    if (servObj.activePolkaDlyaKantselyarskikhPrinadlezhnostei.length) {
        restoreActiveElements(
            servObj.activePolkaDlyaKantselyarskikhPrinadlezhnostei,
            changePolkaKantsPrinadlezhnostei,
            (el) => {
                const side = el.name.includes("left") ? "left" : "right";
                return [side, true, el.userData.placement];
            },
        );
    }
    if (servObj.activeTumbaLeft.length) {
        restoreActiveElements(servObj.activeTumbaLeft, changeTableTumba, (el) => [
            "left",
            el.userData.type,
            true,
            el.userData.placement ?? null,
        ]);
    }
    if (servObj.activeTumbaRight.length) {
        restoreActiveElements(servObj.activeTumbaRight, changeTableTumba, (el) => [
            "right",
            el.userData.type,
            true,
            el.userData.placement ?? null,
        ]);
    }
    if (servObj.activePolkaDlyaKlaviaturi.length) {
        restoreActiveElements(servObj.activePolkaDlyaKlaviaturi, changePolkaDlyaKlaviatury, (el) => {
            const side = el.name.includes("left") ? "left" : "right";
            return [el.userData.type, true, side, el.userData.placement];
        });
    }
    if (servObj.activePolkaVidvizhnayaPodOrgtekhniku.length) {
        restoreActiveElements(servObj.activePolkaVidvizhnayaPodOrgtekhniku, changeShelfEquipment, (el) => {
            const side = el.name.includes("left") ? "left" : "right";
            return [side, true, el.userData.placement];
        });
    }
    if (servObj.activeKonteinerDlyaRabochikhOtkhodov.length) {
        restoreActiveElements(
            servObj.activeKonteinerDlyaRabochikhOtkhodov,
            changeKontainerDlyaRabochikhOtkhodov,
            (el) => {
                const side = el.name.includes("left") ? "left" : "right";
                return [side, true, el.userData.placement];
            },
        );
    }
    if (servObj.activePolkaPribornaya.length && tableSizeType === "width") {
        const polkaYMap = new Map();

        // Создаем карту Y позиций
        servObj.activePolkaPribornaya.forEach(({ userData, position }) => {
            const { inputCount, type } = userData;
            const key = `${type}__${inputCount}`;
            if (!polkaYMap.has(key)) {
                polkaYMap.set(key, position.y);
            }
        });

        // Копия для безопасной итерации
        const copyArray = [...servObj.activePolkaPribornaya];

        copyArray.forEach((polka) => {
            const { inputCount, type, depth, visibleChildren } = polka.userData;
            const name = polka.name;
            const key = `${type}__${inputCount}`;

            // Удаляем из оригинального массива все элементы с именем, содержащим name
            const toDelete = servObj.activePolkaPribornaya.filter((obj) => obj.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            servObj.activePolkaPribornaya = servObj.activePolkaPribornaya.filter((el) => !el.name.includes(name));

            const preservedY = polkaYMap.get(key);
            changePolkaPribornaya(type, depth, inputCount, true, preservedY, visibleChildren);

            let calc_name = isOstrov
                ? `polka_pribornaya_ostrov_${tableSizeValue}`
                : `polka_pribornaya_${type}_${tableSizeValue}`;

            calc_name += type === "dsp" ? `x${depth}__${inputCount}` : `__${inputCount}`;

            setActiveCalcValue(calc_name, true);

            const ogranichiteli = document.querySelectorAll(
                `input[name='polka_pribornaya_ogranichiteli_${inputCount}']:checked`,
            );
            const selectedOgranichiteli = Array.from(ogranichiteli).some((chk) => chk.value === "zadnii")
                ? "zadnii"
                : "";

            if (selectedOgranichiteli) {
                const name = `polka_pribornaya_ogranichiteli_${tableWidth}__${inputCount}`;
                setActiveCalcValue(name, true);
            }
        });
    }
    if (servObj.activeOsveshchenieVerkhnee.length) {
        const { position, name } = servObj.activeOsveshchenieVerkhnee[0];
        const variation = name.includes("naklonnii") ? "naklonnii" : "pryamoi";
        changeOsveshchenieVerkhnee(variation, true, position.y);

        const calc_name = isOstrov
            ? `osveshchenie_verkhnee_ostrov_${tableWidth}`
            : `osveshchenie_verkhnee_${variation}_${tableWidth}`;

        setActiveCalcValue(calc_name, true);
        if (document.querySelector("input[name='instrumentalnaya_planka']:checked")) {
            changeInstrumentalnayaPlanka(true);
            setActiveCalcValue(`instrumentalnaya_planka_${tableWidth}`, true);
        }
        if (document.querySelector("input[name='derzhatel_ruchnogo_instrumenta']:checked")) {
            changeDerzhatelRuchnogoInstrumenta(true);
            setActiveCalcValue(`derzhatel_ruchnogo_instrumenta`, true);
        }
        if (document.querySelector("input[name='derzhatel_ruchnogo_instrumenta__table_front']:checked")) {
            changeDerzhatelRuchnogoInstrumenta(true, "front");
            updateCalcForPlacement("derzhatel_ruchnogo_instrumenta", true, "front", 1);
        }
        if (document.querySelector("input[name='derzhatel_ruchnogo_instrumenta__table_back']:checked")) {
            changeDerzhatelRuchnogoInstrumenta(true, "back");
            updateCalcForPlacement("derzhatel_ruchnogo_instrumenta", true, "back", 1);
        }
    }
    if (servObj.activeOsveshchenieBokovoe.length) {
        reapplyObjectsWithPreservedY(servObj.activeOsveshchenieBokovoe, (el, preservedY) =>
            changeOsveshchenieBokovoe(el.userData.side, true, preservedY, el.userData.placement),
        );
    }
    if (servObj.activePerfopanel.length) {
        const yMap = new Map();

        // Сохраняем позиции по ключу value
        servObj.activePerfopanel.forEach((el) => {
            const name = el.name;
            const value =
                el.userData.width < 1200
                    ? name.includes("left")
                        ? "left"
                        : "right"
                    : name.includes("325")
                      ? "325"
                      : "700";

            if (!yMap.has(value)) {
                yMap.set(value, el.position.y);
            }
        });

        // Удаляем старые и добавляем новые с сохранённой позицией
        servObj.activePerfopanel.forEach((el) => {
            const name = el.name;
            const value =
                el.userData.width < 1200
                    ? name.includes("left")
                        ? "left"
                        : "right"
                    : name.includes("325")
                      ? "325"
                      : "700";

            const toDelete = servObj.activePerfopanel.filter((obj) => obj.name.includes(name));
            servObj.activePerfopanel = servObj.activePerfopanel.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = yMap.get(value);

            isVerstakCategory
                ? changePerfopanelVerstak(value, true, preservedY)
                : changePerfopanel(value, true, preservedY);

            let calc_name = "";
            if (el.userData.width < 1200) {
                const size = tableWidth / 2;
                calc_name = `perfopanel__${size}x325__${value}`;
            } else {
                calc_name = isOstrov
                    ? `perfopanel__ostrov__${tableWidth}x${value}`
                    : `perfopanel__${tableWidth}x${value}`;
            }
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePanelElektromontazhnaya.length) {
        servObj.activePanelElektromontazhnaya.forEach((el) => {
            const name = el.name;

            const toDelete = servObj.activePanelElektromontazhnaya.filter((obj) => obj.name.includes(name));
            // Удаляем из activePanelElektromontazhnaya
            servObj.activePanelElektromontazhnaya = servObj.activePanelElektromontazhnaya.filter(
                (el) => !el.name.includes(name),
            );
            // Удаляем из сцены
            toDelete.forEach((obj) => hideAndRemove(obj));

            const side = el.userData.side;

            changePanelElektromontazhnaya(side, true);
            let calc_name = "";
            if (side) {
                const size = tableWidth / 2;

                calc_name = `panel_elektromontazhnaya__${size}__${side}`;
            } else {
                calc_name = isOstrov
                    ? `panel_elektromontazhnaya__ostrov__${tableWidth}`
                    : `panel_elektromontazhnaya__${tableWidth}`;
            }

            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activeLotokMetallicheskii.length) {
        const yMap = new Map();

        // Сохраняем позицию по Y для каждого side
        servObj.activeLotokMetallicheskii.forEach((el) => {
            const { side } = el.userData;

            if (!yMap.has(side)) {
                yMap.set(side, el.position.y);
            }
        });

        // Удаляем и создаём заново, передавая сохранённую позицию
        servObj.activeLotokMetallicheskii.forEach((el) => {
            const { name, side } = el.userData;

            const toDelete = servObj.activeLotokMetallicheskii.filter((obj) => obj.name.includes(name));
            servObj.activeLotokMetallicheskii = servObj.activeLotokMetallicheskii.filter(
                (el) => !el.name.includes(name),
            );
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = yMap.get(side);
            changeLotokMetallicheskii(side, true, preservedY);
            let calc_name = "";
            if (side) {
                const size = tableWidth / 2;

                calc_name = `lotok_metallicheskii__${size}__${side}`;
            } else {
                calc_name = `lotok_metallicheskii__${tableWidth}`;
            }
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePlankaDlyaLotkov.length) {
        const yMap = new Map();

        // Сохраняем позицию по Y для каждой стороны
        servObj.activePlankaDlyaLotkov.forEach((el) => {
            const { side } = el.userData;

            if (!yMap.has(side)) {
                yMap.set(side, el.position.y);
            }
        });

        // Удаляем старые и создаём новые с сохранением позиции
        servObj.activePlankaDlyaLotkov.forEach((el) => {
            const { name, side } = el.userData;

            const toDelete = servObj.activePlankaDlyaLotkov.filter((obj) => obj.name.includes(name));
            servObj.activePlankaDlyaLotkov = servObj.activePlankaDlyaLotkov.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = yMap.get(side);
            changePlankaDlyaLotkov(side, true, preservedY);
            let calc_name = "";
            if (side) {
                const size = tableWidth / 2;

                calc_name = `planka_dlya_lotkov__${size}__${side}`;
            } else {
                if (isOstrov) calc_name = `planka_dlya_lotkov__ostrov__${servObj.tableSize.tableWidth.current}`;
                if (isSMK) calc_name = `planka_dlya_lotkov__smk__${servObj.tableSize.tableWidth.current}`;
            }
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePolkaKorotkaya.length) {
        const yMap = new Map();

        // Сохраняем позицию по Y для каждой комбинации side + depth
        servObj.activePolkaKorotkaya.forEach((el) => {
            const name = el.name;
            const side = name.includes("left") ? "left" : "right";
            const depth = name.includes("300") ? "300" : "400";
            const key = `${side}__${depth}`;

            if (!yMap.has(key)) {
                yMap.set(key, el.position.y);
            }
        });

        // Удаляем старые и создаём новые с сохранением Y
        servObj.activePolkaKorotkaya.forEach((el) => {
            const name = el.name;
            const side = name.includes("left") ? "left" : "right";
            const depth = name.includes("300") ? "300" : "400";
            const key = `${side}__${depth}`;

            const toDelete = servObj.activePolkaKorotkaya.filter((obj) => obj.name.includes(name));
            servObj.activePolkaKorotkaya = servObj.activePolkaKorotkaya.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = yMap.get(key);
            changePolkaKorotkaya(side, depth, true, preservedY);
            const size = tableWidth / 2;

            const calc_name = `polka_korotkaya__${size}x${depth}__${side}`;
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePolkaNaklonnaya.length) {
        const yMap = new Map();

        servObj.activePolkaNaklonnaya.forEach((el) => {
            const name = el.name;
            const side = name.includes("left") ? "left" : "right";
            const key = `${side}`;

            if (!yMap.has(key)) {
                yMap.set(key, el.position.y);
            }
        });

        // Удаляем старые и создаём новые с сохранением Y
        servObj.activePolkaNaklonnaya.forEach((el) => {
            const name = el.name;
            const side = name.includes("left") ? "left" : "right";
            const key = `${side}`;

            const toDelete = servObj.activePolkaNaklonnaya.filter((obj) => obj.name.includes(name));
            servObj.activePolkaNaklonnaya = servObj.activePolkaNaklonnaya.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = yMap.get(key);
            changePolkaNaklonnaya(side, true, preservedY);
            const size = tableWidth / 2;

            const calc_name = `polka_naklonnaya__${size}x300__${side}`;
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activeDerzhatelMonitora.length) {
        const isSMK = servObj.redactorModeObject.name.includes("smk");

        reapplyObjectsWithPreservedY(
            servObj.activeDerzhatelMonitora,
            (el, preservedY) => {
                let value = el.name.split("__")[2].split("_")[0];
                if (isSMK) value = el.name.split("__")[3].split("_")[0];
                const side = el.name.includes("left") ? "left" : "right";
                changeDerzhatelMonitora(value, true, side, preservedY, el.userData.placement);
            },
            (el) => {
                let value = el.name.split("__")[2].split("_")[0];
                if (isSMK) value = el.name.split("__")[3].split("_")[0];
                const side = el.name.includes("left") ? "left" : "right";
                return `${value}__${side}__${el.userData.placement}`;
            },
        );
    }
    if (servObj.activePolkaDlyaKlaviaturiIMishi.length) {
        reapplyObjectsWithPreservedY(servObj.activePolkaDlyaKlaviaturiIMishi, (el, preservedY) =>
            changePolkaDlyaKlaviaturiIMishi(el.userData.side, true, preservedY, el.userData.placement),
        );
    }
    if (servObj.activeKronshteinDlyaPrintera.length) {
        reapplyObjectsWithPreservedY(servObj.activeKronshteinDlyaPrintera, (el, preservedY) =>
            changeKronshteinDlyaPrintera(el.userData.side, true, preservedY, el.userData.placement),
        );
    }
    if (servObj.activePodstavkaDlyaChertezhei.length) {
        reapplyObjectsWithPreservedY(servObj.activePodstavkaDlyaChertezhei, (el, preservedY) =>
            changePodstavkaDlyaChertezhei(el.userData.side, true, preservedY, el.userData.placement),
        );
    }
    if (servObj.activeInstrumentalnayaPlanka.length) {
        changeInstrumentalnayaPlanka(true);
    }
    if (servObj.activeYashchikMKPlastik.length) {
        restoreActiveElements(servObj.activeYashchikMKPlastik, changeYashchikMKPlastik, (el) => {
            const side = el.name.includes("left") ? "left" : "right";
            return [side, true, el.userData.placement];
        });
    }
    if (servObj.activeYashchikMKMetall.length) {
        restoreActiveElements(servObj.activeYashchikMKMetall, changeYashchikMKMetall, (el) => {
            const side = el.name.includes("left") ? "left" : "right";
            return [side, true, el.userData.placement];
        });
    }
    if (servObj.activeDerzhatelRulonaNizhnii.length) {
        restoreActiveElements(servObj.activeDerzhatelRulonaNizhnii, changeDerzhatelRulonaNizhnii, (el) => {
            const { side } = el.userData;
            return [true, side];
        });
        const width = servObj.tableSize.tableWidth.current;
        setActiveCalcValue(`derzhatel_rulona__nizhnii__${width}`, true);
    }

    // VERSTAK

    if (servObj.activeVerstakTumbaRight.length) {
        changeVarstakTumba(servObj.activeVerstakTumbaRight[0]?.name, "right", true);
    }
    if (servObj.activeVerstakTumbaLeft.length) {
        changeVarstakTumba(servObj.activeVerstakTumbaLeft[0]?.name, "left", true);
    }
    if (servObj.activeVerstakNozhkiRight.length) {
        changeVerstakNozhki("right", true);
    }
    if (servObj.activeVerstakNozhkiLeft.length) {
        changeVerstakNozhki("left", true);
    }
    if (servObj.activeVerstakStoleshnitsa.length) {
        changeVarstakStoleshnitsa(true);
    }

    if (servObj.activeDerzhatelRulonaVerkhnii.length && tableSizeType === "width") {
        // Создаем Map с ключом по inputCount
        const YMap = new Map();

        let copyArray = [...servObj.activeDerzhatelRulonaVerkhnii];

        copyArray.forEach((el) => {
            const { inputCount, side } = el.userData;
            const key = `${inputCount}__${side}`;
            if (!YMap.has(key)) {
                YMap.set(key, el.position.y);
            }
        });

        copyArray.forEach((el) => {
            const { inputCount, isHalfObj, side, visibleChildren } = el.userData;
            const name = el.name;
            const key = `${inputCount}__${side}`;

            const toDelete = copyArray.filter((obj) => obj.name.includes(name));
            copyArray = servObj.activeDerzhatelRulonaVerkhnii.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = YMap.get(key);
            changeDerzhatelRulonaUp({ isChecked: true, inputCount, isHalfObj, preservedY, side });

            if (visibleChildren.some((el) => el.includes("bokovie_fiksatori_rulona"))) {
                changeBokovieFiksatoriUp({ isChecked: true, inputCount, isHalfObj, side });
            }

            const calc_name = isHalfObj
                ? `derzhatel_rulona_verkhnii__${tableSizeValue / 2}__${side}`
                : `derzhatel_rulona_verkhnii__${tableSizeValue}__${inputCount}`;

            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activeFiksatorRulonnikhMaterialov.length && tableSizeType === "width") {
        // Создаем Map с ключом по inputCount
        const YMap = new Map();

        let copyArray = [...servObj.activeFiksatorRulonnikhMaterialov];

        copyArray.forEach((el) => {
            const { side } = el.userData;
            const key = side;
            if (!YMap.has(key)) {
                YMap.set(key, el.position.y);
            }
        });

        copyArray.forEach((el) => {
            const { isHalfObj, side } = el.userData;
            const name = el.name;
            const key = side;

            const toDelete = copyArray.filter((obj) => obj.name.includes(name));
            copyArray = servObj.activeFiksatorRulonnikhMaterialov.filter((el) => !el.name.includes(name));
            toDelete.forEach((obj) => hideAndRemove(obj));

            const preservedY = YMap.get(key);
            changeFiksatorRulonnikhMaterialov({ isChecked: true, isHalfObj, preservedY, side });

            const calc_name = isHalfObj
                ? `fiksatori_rulonnikh_materialov__${tableSizeValue / 2}`
                : `fiksatori_rulonnikh_materialov__${tableSizeValue}`;

            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activeDerzhatelRulonaBokovoi.length) {
        const coppyArray = [...servObj.activeDerzhatelRulonaBokovoi];
        coppyArray.forEach((el) => {
            const { side, visibleChildren } = el.userData;
            changeDerzhatelRulonaBokovoi(true, side, visibleChildren);

            const calc_name = `derzhatel_rulona_bokovoi__${tableDepth}__${side}`;
            setActiveCalcValue(calc_name, true);
        });
    }
    if (servObj.activePolkaPribornayaKSM.length && tableSizeType === "width") {
        const polka = servObj.activePolkaPribornayaKSM[0];
        const { userData, position } = polka;
        const { visibleChildren } = userData;
        const preservedY = position.y;

        changePolkaPribornayaKSM(preservedY, visibleChildren);
    }
    if (servObj.activePerfopanelKSM.length && tableSizeType === "width") {
        const perfopanel = servObj.activePerfopanelKSM[0];
        const { position } = perfopanel;
        const preservedY = position.y;

        changePerfopanelKSM(preservedY);
    }
    if (servObj.activeDerzhatelRulonaStoyka.length) {
        const copyArray = [...servObj.activeDerzhatelRulonaStoyka];
        copyArray.forEach((el) => {
            const { count } = el.userData;
            changeStoykiDerzhatelRulona(true, count);
        });
    }
    if (servObj.activeVerstakPerekladini.length && tableSizeType === "width") {
        changeVerstakPerekladini(true);
    }
    if (visibleChildren?.length) {
        // Функция для проверки, есть ли вообще такой чилдрен у текущего стола
        const hasChild = (string) => {
            return servObj.redactorModeObject.children.some((el) => el.name.includes(string));
        };

        // Для стола "Раскройный" (разделители)
        if (hasChild("razdelitel")) {
            const count = document.querySelector("input[name='razdeliteli_amount']").value;
            changeRazdeliteliDownRaskroinii(Number(count));
        }
        if (hasChild("dopolnitelnoe_pokritie_polok__otsinkovka__stol")) {
            changePokritiePolokSP(true, "zink");

            setActiveCalcValue(`zink__${tempName}__${tableWidth}x${tableDepth}`, true);
        }
    }
    if (servObj.activeElektropanelSP.length) {
        changeElektropanelSP(true);
    }

    if (servObj.activeTumbaSP.length) {
        const [_, value] = servObj.activeTumbaSP[0].name.split("__");
        const side = servObj.activeTumbaSP[0].userData.side;
        changeTableTumbaSP(value, true, side);
    }
    if (servObj.activeRuchkaSP.length) {
        changeRuchkaSyomnaya(true);
        const isPSP = tempName === "psm";
        setActiveCalcValue(`ruchka__${tempName}__${isPSP ? tableDepth : tableWidth}`, true);
    }
    if (servObj.activeTumbaSP.length) {
        const copyArray = [...servObj.activeTumbaSP];
        copyArray.forEach((el) => {
            const { type, side } = el.userData;

            changeTableTumbaSP(type, true, side);
        });
    }
    if (servObj.activePolkaStellazh.length) {
        if (tableSizeType === "height") {
            servObj.building.MAX_Y_VALUES.default = MIN_MAX_STELLAZHI[servObj.tempName][tableSizeValue];
        }

        const maxY = servObj.building.MAX_Y_VALUES.default.max;
        const stellazhName = servObj.tempName;

        // Сохраняем массив (копируем)
        const coppyArray = servObj.activePolkaStellazh.map((el) => ({
            position: { ...el.position },
            userData: { ...el.userData },
        }));

        // Сначала вычищаем все полки в оригинальном массива
        servObj.activePolkaStellazh.forEach((el) => {
            hideAndRemove(el);
            servObj.activePolkaStellazh = servObj.activePolkaStellazh.filter((item) => item.name !== el.name);
        });

        // Обновляем позиции полок, пробегаясь по копии массива
        coppyArray.forEach(({ position, userData }) => {
            const preservedY = userData.verticalOnly ? Math.min(position.y, maxY) : null;
            changePolkaStellazhi(userData.count, userData.verticalOnly, true, preservedY);
        });

        // Сбрасываем calc и сохраняем piece активной полки
        const polkaWidth = servObj.tableSize.tableWidth.current;
        const polkaDepth = servObj.tableSize.tableDepth.current;

        const calcEntries = Object.entries(servObj.calc).filter(([key]) => key.includes("polka__stellazhi"));
        const activeEntry = calcEntries.find(([_, data]) => data.active);
        const piece = activeEntry?.[1].piece ?? 0; // сохраняем до сброса

        calcEntries.forEach(([_, data]) => {
            data.piece = 0;
            data.active = false;
        });

        setActiveCalcValue(`polka__stellazhi__${stellazhName}__${polkaWidth}x${polkaDepth}`, true, piece);
    }
    if (servObj.activePolkaPribornayaSMK?.length) {
        const coppyArray = [...servObj.activePolkaPribornayaSMK];
        coppyArray.forEach((polka) => {
            const preservedY = polka.position.y;
            const { visibleChildren } = polka.userData;
            changePolkaPribornayaSMK(preservedY, visibleChildren);
        });
    }
    if (servObj.activeVerstakOpora?.length) {
        const coppyArray = [...servObj.activeVerstakOpora];
        coppyArray.forEach((opora) => {
            const { side } = opora.userData;
            changeVerstakOpora(side, true);
        });
    }
    if (servObj.activeVerstakPolka?.length) {
        const currentPolka = servObj.activeVerstakPolka[0];
        const { side } = currentPolka.userData;
        changeVerstakPolka(side);
    }
    if (servObj.activeWardrobeDoors?.length) {
        changeDoors(true);
    }
    if (servObj.activePolkaWardrobe.length) {
        if (tableSizeType === "height") {
            servObj.building.MAX_Y_VALUES.default = MIN_MAX_SHKAFY[servObj.tempName][tableSizeValue];
        }

        const maxY = servObj.building.MAX_Y_VALUES.default.max;
        const stellazhName = servObj.tempName;

        // Сохраняем массив (копируем)
        let coppyArray = servObj.activePolkaWardrobe.map((el) => ({
            position: { ...el.position },
            userData: { ...el.userData },
        }));

        if (tableSizeValue === 1000) {
            coppyArray = [coppyArray[0], coppyArray[1]];
        }

        // Сначала вычищаем все полки в оригинальном массива
        servObj.activePolkaWardrobe.forEach((el) => {
            hideAndRemove(el);
            servObj.activePolkaWardrobe = servObj.activePolkaWardrobe.filter((item) => item.name !== el.name);
        });

        // Обновляем позиции полок, пробегаясь по копии массива
        coppyArray.forEach(({ position, userData }) => {
            changePolkaWardrobes(userData.count, userData.verticalOnly, true);
        });

        // Сбрасываем calc и сохраняем piece активной полки

        const polkaWidth = servObj.tableSize.tableWidth.current;
        const polkaDepth = servObj.tableSize.tableDepth.current;

        const calcEntries = Object.entries(servObj.calc).filter(([key]) => key.includes("polka__wardrobes"));
        const activeEntry = calcEntries.find(([_, data]) => data.active);
        const piece = activeEntry?.[1].piece ?? 0; // сохраняем до сброса

        calcEntries.forEach(([_, data]) => {
            data.piece = 0;
            data.active = false;
        });

        // setActiveCalcValue(`polka__stellazhi__${stellazhName}__${polkaWidth}x${polkaDepth}`, true, piece);
    }
}

/**
 * Повторно применяет объекты с сохранением их Y-позиции,
 * учитывает side и placement для точного удаления и перевызова.
 *
 * Используется при изменении размера стола,
 * чтобы объекты сохраняли свои позиции по высоте (Y) и корректно отображались на нужной стороне.
 *
 * @param {Array} activeArray - массив активных объектов, которые нужно перевызвать (например servObj.activePolkaDlyaKlaviaturiIMishi)
 * @param {Function} changeFn - функция для добавления/перевызова объекта. Принимает два аргумента:
 *   - el: объект из activeArray
 *   - preservedY: сохранённая Y-позиция для этого объекта
 * @param {Function} [getKey] - функция, формирующая уникальный ключ для объекта,
 *   используемый для сохранения Y и точного удаления. По умолчанию: `${side}__${placement}`
 *
 * @example
 * reapplyObjectsWithPreservedY(
 *   servObj.activePolkaDlyaKlaviaturiIMishi,
 *   (el, preservedY) => changePolkaDlyaKlaviaturiIMishi(el.userData.side, true, preservedY, el.userData.placement)
 * );
 */
function reapplyObjectsWithPreservedY(
    activeArray,
    changeFn,
    getKey = (el) => `${el.userData.side}__${el.userData.placement}`,
) {
    if (!activeArray.length) return;

    // Создаём карту для хранения Y-позиций по уникальному ключу (side + placement)
    const yMap = new Map();

    // Делаем копию массива, чтобы безопасно итерироваться при изменении оригинала
    const copyArray = [...activeArray];

    // Сохраняем Y-позицию для каждого уникального ключа
    copyArray.forEach((el) => {
        const key = getKey(el);
        if (!yMap.has(key)) yMap.set(key, el.position.y);
    });

    // Перебираем копию и перевызываем объекты
    copyArray.forEach((el) => {
        const key = getKey(el);

        // 1️⃣ Удаляем старые объекты с этим ключом из оригинального массива и сцены
        const toDelete = activeArray.filter((obj) => getKey(obj) === key);
        activeArray = activeArray.filter((obj) => getKey(obj) !== key);
        toDelete.forEach((obj) => hideAndRemove(obj));

        // 2️⃣ Получаем сохранённую Y-позицию для этого объекта
        const preservedY = yMap.get(key);

        // 3️⃣ Вызываем функцию добавления/перевызова объекта
        changeFn(el, preservedY);
    });
}
